/** Group size that authenticator apps use when they show a key, and that reads well aloud. */
const GROUP_SIZE = 4;

/**
 * Formats a raw base32 TOTP secret for reading or typing by hand: whitespace stripped,
 * upper-cased, split into groups of four ("JBSW Y3DP EHPK 3PXP"). Authenticator apps ignore
 * the spaces on input, so the grouped form is safe to paste as well as to read.
 */
export const formatTotpSecretForDisplay = (secret: string): string => {
	const compact = secret.replace(/\s+/g, "").toUpperCase();
	const groups = compact.match(new RegExp(`.{1,${GROUP_SIZE}}`, "g"));

	return groups?.join(" ") ?? "";
};
